import ALink from '../components/common/ALink';
import MetaHeader from '../components/common/MetaHeader';

export default function RentalFeesCancellations() {
  return (
    <>
    <MetaHeader title={'Rental Fees & Cancellations'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Rental Fees & Cancellations
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <div className="subpage">
          <h1 className="subpage__title">Cancellations</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              Customers can only cancel an order before the item has been shipped, as customers are financially responsible for shipped items. Customers may be charged a restocking fee.  For additional information regarding restocking fees please refer to the section for Rental and Restocking Fees.
            </p>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph bolder">
              Customers are required to email:
              <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                info@buyontrust.com
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Subject line:
              <a
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                Cancellation
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Provide a full explanation of what you believe happened and why you want to cancel.
            </p>
          </div>

          <p className="subpage__paragraph">
            Additional costs might be incurred by cancelling and/or replacing any item(s), and many lease providers require a minimum dollar value to be maintained on a lease. This means you might be required to return all items on your lease or maintain a higher dollar value on your lease than was previously agreed to. This could also result in rental fees. By speaking with BuyOnTrust first, we can help you make an informed decision.
          </p>
          <p className="subpage__paragraph">
            Please allow 1-3 business days for initial responses from the BuyOnTrust Quality Assurance team.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </div>
        <div className="subpage">
          <h1 className="subpage__title">Rental and Restocking Fees</h1>
          <p className="subpage__paragraph">
            Customers may be subject to a rental fee and/or restocking fee at BuyOnTrust’s discretion. These are separate from your lease. BuyOnTrust will notify a customer from info@buyontrust.com if a rental fee and/or restocking fee is required. Rental fees and restocking fees are to be paid in full immediately upon receiving the payment request from PayPal and will be associated with Dorado Management LLC. BuyOnTrust reserves the right to notify a lease provider if the customer has not made a full and complete return due to an unpaid rental fee and or restocking fee balance.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </div>
      </div>
    </main>
    </>
  );
}
